import React, { useEffect, useState, useContext } from 'react'
import { MapContainer, Marker, Popup, TileLayer, useMapEvents, useMap } from "react-leaflet";
import L from 'leaflet';
import * as GeoSearch from 'leaflet-geosearch';

declare type MapProps = {
  position: any,
  setPosition: (text: any) => void;
}

export const MapCont = ({ position, setPosition }: MapProps) => {
  const [loadSearch, setLoadSearch] = useState<number>(0)

  let DefaultIcon = L.icon({
    iconUrl: '/assetes/media/pin2.png',
    iconSize: new L.Point(35, 43),
  });
  L.Marker.prototype.options.icon = DefaultIcon;

  const changeLocation = (lat: any, lng: any) => {
    setPosition([lat, lng])
  }

  return (
    <MapContainer
      center={position != null ? position : [35.7001861, 51.3390245]}
      zoom={14}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <DrogMap changeLocation={changeLocation} />
      <Marker position={position != null ? position : [35.7001861, 51.3390245]} >
      </Marker>
      <Search loadSearch={loadSearch} setLoadSearch={setLoadSearch} />
      <FlyTo position={position != null ? position : [35.7001861, 51.3390245]} />
    </MapContainer>
  )
}


export function DrogMap(props: any) {
  useMapEvents({
    drag: (e: any) => {
      props.changeLocation(e.target.getCenter().lat, e.target.getCenter().lng)
    }
  });
  return null
}



export function Search(props: any) {
  props.setLoadSearch(1)
  const map = useMap()
  useEffect(() => {
    if (props && props.loadSearch == 0) {
      //@ts-ignore
      const search = new GeoSearch.GeoSearchControl({
        style: 'bar',
        provider: new GeoSearch.OpenStreetMapProvider({

        }),
        showMarker: false,
      });
      map.addControl(search);

    }
  }, [props.loadSearch])

  return null

}


export function FlyTo({ position }: { position: [number, number] }) {
  const map = useMap()

  useEffect(() => {
    map.flyTo(position)
    // map.setView(position) 
  }, [position])

  return null
}
